export const volumes = [
  {
    n: 'I',
    color: '#1565F0',
    title: 'Clear Aligner Case Assessment & Clinical Foundations',
    intro: 'Learn a structured approach to organizing the information needed for a clear aligner case review.',
    items: [
      'Clinical record organization framework.',
      'Patient presentation and chief concern worksheet.',
      'Relevant medical and dental history considerations.',
      'Extraoral and intraoral findings review.',
      'Occlusal findings documentation.',
      'Diagnostic information checklist.',
      'Initial case assessment worksheet.',
      'Questions to address before treatment planning.',
      'Case summary template.',
    ],
    purpose: 'Establish an organized foundation before developing treatment objectives.',
  },
  {
    n: 'II',
    color: '#0F9F6E',
    title: 'From Clinical Findings to Treatment Objectives',
    intro: 'Explore a structured method for documenting findings and connecting them to treatment-planning considerations.',
    items: [
      'Clinical findings summary.',
      'Problem identification worksheet.',
      'Primary and secondary objective mapping.',
      'Objective prioritization framework.',
      'Alignment and space considerations.',
      'Occlusal objective documentation.',
      'Esthetic and functional considerations.',
      'Objective review checklist.',
      'Case-planning summary template.',
    ],
    purpose: 'Organize the relationship between the findings identified and the objectives being considered.',
  },
  {
    n: 'III',
    color: '#7A3FE4',
    title: 'Clear Aligner Biomechanics & Movement Considerations',
    intro: 'Review the biomechanical questions that may arise when evaluating proposed clear aligner movements.',
    items: [
      'Tooth movement terminology and review.',
      'Translation and tipping considerations.',
      'Rotation and root-control considerations.',
      'Intrusion and extrusion review.',
      'Attachment-related considerations.',
      'Anchorage and force-system questions.',
      'Movement predictability factors.',
      'Potential limitations and trade-offs.',
      'Biomechanical review checklist.',
    ],
    purpose: 'Provide a structured educational framework for identifying questions that deserve closer biomechanical review.',
  },
  {
    n: 'IV',
    color: '#E8730C',
    title: 'Treatment Sequencing & Digital Planning Review',
    intro: 'Organize the review of proposed treatment stages and the logic behind a digital treatment plan.',
    items: [
      'Treatment sequence mapping.',
      'Stage-by-stage review worksheet.',
      'Space management considerations.',
      'Movement coordination questions.',
      'Attachment and staging review.',
      'Digital setup evaluation checklist.',
      'Identification of potential inconsistencies.',
      'Treatment objective alignment review.',
      'Digital planning summary template.',
    ],
    purpose: 'Help organize the review of a proposed treatment sequence before clinical decisions are finalized.',
  },
  {
    n: 'V',
    color: '#D6334A',
    title: 'Tracking, Refinement & Treatment Reassessment',
    intro: 'Create a structured approach to documenting treatment progress and identifying issues that require further evaluation.',
    items: [
      'Progress review framework.',
      'Tracking discrepancy documentation.',
      'Patient compliance considerations.',
      'Clinical observation checklist.',
      'Potential causes to investigate when progress differs from expectations.',
      'Refinement assessment worksheet.',
      'Reassessment questions.',
      'Documentation of revised considerations.',
      'Follow-up review template.',
    ],
    purpose: 'Organize observations and questions throughout treatment without assuming that one solution is appropriate for every case.',
  },
  {
    n: 'VI',
    color: '#0A8FC2',
    title: 'The Complete Clear Aligner Case Review Blueprint',
    intro: 'Bring the concepts from the previous volumes together in one coordinated case-review system.',
    items: [
      'Comprehensive case assessment map.',
      'Clinical findings summary.',
      'Treatment objective review.',
      'Biomechanical considerations checklist.',
      'Treatment sequencing overview.',
      'Monitoring and reassessment framework.',
      'Case documentation structure.',
      'Final case-review worksheet.',
      'Reusable planning summary.',
    ],
    purpose: 'Consolidate the six-stage framework into a practical reference for organizing case reviews.',
  },
]
